module.exports = __webpack_public_path__ + "img/ic_delete2.6ce4f505.svg";